import React, { useEffect } from "react";
import styles from "../OrderDetails.module.scss";
import { strings } from "../../../../../intl/fa";
import { digitsToHindi, percentCalc, toMoneyFormat } from "@bale/utils";
import { GetAdReportResponse } from "../../../../../core/ordersList/ordersList.api";
import { Row } from "../DetailCard";
import { getClickCountMultiplier } from "../../../../../utils/utils";
import { useRequest } from "../../../../../hooks/useRequest";
import { getAdReportThunk } from "../../../../../core/ordersList/ordersList.thunk";
import { dateTimeWithDash } from "utils/time";
import { AdSpot } from "core/orderAd/orderAd.entity";

type Props = {
  reportData: GetAdReportResponse;
  spot: AdSpot;
  isActive?: boolean;
};
export const OrderReport: React.FC<React.PropsWithChildren<Props>> = ({
  reportData,
  spot,
  isActive,
}) => {
  const { sendRequest } = useRequest(getAdReportThunk);
  useEffect(() => {
    const interval = setInterval(() => {
      if (isActive) {
        sendRequest({ ad_id: reportData.ad_id });
      }
    }, 5000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  const clickCount =
    reportData.click_count * getClickCountMultiplier(reportData.start_time);
  const viewCount = reportData.view_count;
  const shouldShowViewClick = spot === AdSpot.AdSpotDialog || viewCount !== 0;

  return (
    <div className={styles.Card}>
      <div className={styles.LabelWrapper}>
        <p className={styles.Title}>{strings.order_details.ad_report}</p>
      </div>
      <div className={styles.InfoWrapper}>
        <Row
          rowKey={strings.order_details.show_date}
          value={dateTimeWithDash(reportData.start_time)}
        />
        {shouldShowViewClick && (
          <>
            <Row
              rowKey={strings.order_details.view_count}
              value={digitsToHindi(toMoneyFormat(String(viewCount)))}
            />
            <Row
              rowKey={strings.order_details.click_count}
              value={digitsToHindi(toMoneyFormat(String(clickCount)))}
            />
            <Row
              rowKey={strings.order_details.ctr}
              value={digitsToHindi(
                toMoneyFormat(percentCalc(clickCount, viewCount))
              )}
            />
          </>
        )}
      </div>
    </div>
  );
};
